'use strict';

var SvgZoom = /** @class */ (function () {
    function SvgZoom(svg) {
        this.init(svg);
    }

    /** Init **/
    SvgZoom.prototype.init = function (svg) {
        this.svg = svg;
        this.viewBox = this.svg.viewBox.baseVal;
        this.baseX = this.viewBox.x;
        this.baseY = this.viewBox.y;
        this.baseWidth = this.viewBox.width;
        this.baseHeight = this.viewBox.height;
        this.zoomedWidth = Math.round(this.baseWidth / 2);
        this.zoomedHeight = Math.round(this.baseHeight / 2);

        this.addEvents();
    };

    SvgZoom.prototype.addEvents = function () {
        var self = this;

        this.svg.addEventListener("touchmove", function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            var rect = self.svg.getBoundingClientRect();
            var touchX = e.touches[0].clientX - rect.left;
            var touchY = e.touches[0].clientY - rect.top;
            var newX = Math.round((touchX * self.zoomedWidth) / rect.width);
            var newY = Math.round((touchY * self.zoomedHeight) / rect.height);

            self.viewBox.width = self.zoomedWidth;
            self.viewBox.height = self.zoomedHeight;
            self.viewBox.x = newX;
            self.viewBox.y = newY;
        });
        this.svg.addEventListener("touchend", function () {
            self.viewBox.width = self.baseWidth;
            self.viewBox.height = self.baseHeight;
            self.viewBox.x = self.baseX;
            self.viewBox.y = self.baseY;
        });

        this.svg.addEventListener("mousemove", function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            var rect = self.svg.getBoundingClientRect();
            var layerX = e.offsetX;
            var layerY = e.offsetY;

            if (layerX < 0) {
                layerX = Math.abs(offsetX + rect.width);
            }
            if (layerY < 0) {
                layerY = Math.abs(offsetY + rect.width);
            }

            var newX = Math.round((layerX * self.zoomedWidth) / rect.width);
            var newY = Math.round(((layerY * self.zoomedHeight) / rect.height));
            
            if (isFinite(newX) && isFinite(newY)) {
                self.viewBox.width = self.zoomedWidth;
                self.viewBox.height = self.zoomedHeight;
                self.viewBox.x = newX;
                self.viewBox.y = newY;
            }
        });
        this.svg.addEventListener("mouseleave", function () {
            self.viewBox.width = self.baseWidth;
            self.viewBox.height = self.baseHeight;
            self.viewBox.x = self.baseX;
            self.viewBox.y = self.baseY;
        });
    }

    SvgZoom.prototype.destroy = function () {

    }
    
    /* End AJAX Functions */

    return SvgZoom;
}());